import { render, staticRenderFns } from "./FloatingBar.vue?vue&type=template&id=a0ecfb96&scoped=true&"
import script from "./FloatingBar.vue?vue&type=script&lang=js&"
export * from "./FloatingBar.vue?vue&type=script&lang=js&"
import style0 from "./FloatingBar.vue?vue&type=style&index=0&id=a0ecfb96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ecfb96",
  null
  
)

export default component.exports